export default __webpack_public_path__ + "static/media/IMG_5548.2ce32131.jpg";